import { useInfluencerInfoStore } from './useInfluencerInfoStore';

/**
 * 达人信息 hook：在 Navbar 中发起请求并写入 store，
 * 任意有 Navbar 的页面可通过此 hook 读取，用法：const { influencers, user } = influencerInfo || {}
 *
 * - code !== 0 已在 hook 内拦截并 toast，调用方只需判断 influencerInfo 是否有值
 * @returns influencerInfo - { influencers, user }，未请求或失败时为 null
 * @returns loading - 请求中为 true
 * @returns error - 请求失败时的错误
 * @returns refresh - 主动拉取最新达人信息（会更新 store，供全局使用）
 */
export function useInfluencerInfo(): {
  influencerInfo: any;
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<any>;
} {
  const influencerInfo = useInfluencerInfoStore((s) => s.influencerInfo);
  const loading = useInfluencerInfoStore((s) => s.loading);
  const error = useInfluencerInfoStore((s) => s.error);
  const fetchInfluencerInfo = useInfluencerInfoStore(
    (s) => s.fetchInfluencerInfo
  );

  return {
    influencerInfo,
    loading,
    error,
    refresh: fetchInfluencerInfo
  };
}
